import {
  CAMPAIGNS_PATH,
  REFERRAL_CODE_QUERY,
  UTM_CAMPAIGN_QUERY,
  UTM_SOURCE_QUERY,
} from '@ping/constants/campaigns.constant';

const storageKey = (campaignSlug: string) => `CAMPAIGN_MARKETING_CHANNEL:${campaignSlug}`;

export interface BuildCampaignMarketingChannelLinkOptions {
  referralCode?: string | null;
  origin?: string;
}

export function buildCampaignMarketingChannelLink(
  campaignSlug: string,
  channelCode: string,
  options?: BuildCampaignMarketingChannelLinkOptions
): string {
  const baseOrigin = options?.origin ?? (typeof window !== 'undefined' ? window.location.origin : '');
  const params = new URLSearchParams();
  params.set(UTM_CAMPAIGN_QUERY, campaignSlug);
  params.set(UTM_SOURCE_QUERY, channelCode.trim().toLowerCase());

  const referralCode = options?.referralCode?.trim();
  if (referralCode) {
    params.set(REFERRAL_CODE_QUERY, referralCode);
  }

  return `${baseOrigin}${CAMPAIGNS_PATH}?${params.toString()}`;
}

export function persistMarketingChannel(campaignSlug: string, channelCode?: string | null): void {
  if (!campaignSlug || !channelCode?.trim()) {
    return;
  }

  if (typeof window !== 'undefined') {
    localStorage.setItem(storageKey(campaignSlug), channelCode.trim().toLowerCase());
  }
}

export function resolveMarketingChannel(
  campaignSlug: string | undefined,
  query?: Record<string, string | string[] | undefined>
): string | null {
  const fromQuery = query?.[UTM_SOURCE_QUERY];
  if (typeof fromQuery === 'string' && fromQuery.trim()) {
    return fromQuery.trim().toLowerCase();
  }

  if (typeof window !== 'undefined') {
    const fromSearch = new URLSearchParams(window.location.search).get(UTM_SOURCE_QUERY);
    if (fromSearch?.trim()) {
      return fromSearch.trim().toLowerCase();
    }
  }

  if (campaignSlug && typeof window !== 'undefined') {
    const stored = localStorage.getItem(storageKey(campaignSlug));
    if (stored?.trim()) {
      return stored.trim().toLowerCase();
    }
  }

  return null;
}

export function captureMarketingChannelFromQuery(
  campaignSlug: string | undefined,
  query: Record<string, string | string[] | undefined>
): void {
  if (!campaignSlug) {
    return;
  }

  persistMarketingChannel(campaignSlug, resolveMarketingChannel(campaignSlug, query));
}
